import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { RUN_AUTOMATION_VERSION_KEY } from '@/utils/queryKeys.ts';
import { AxiosError } from 'axios';
import { run_automation_version_url } from '@/utils/urls.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { RunAutomationVersion } from '@/types/automations.ts';

const useRetrieveRunAutomationVersion = (
  runId?: string,
): UseQueryResult<RunAutomationVersion, AxiosError> => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();

  return useQuery({
    queryKey: RUN_AUTOMATION_VERSION_KEY(automationId, runId),
    queryFn: async () => {
      const response = await apiClient.get(run_automation_version_url(runId));
      return response.data;
    },
    enabled: !!runId,
  });
};

export default useRetrieveRunAutomationVersion;
